import { Children as t, isValidElement as u, cloneElement as f } from "react";
function w(p) {
  const n = {};
  return l(i(p, n), n);
}
let m = 0;
function i(p, n) {
  return t.map(p, (r) => {
    if (/* @__PURE__ */ u(r)) {
      const e = {};
      return r.props.id != null && (n[r.props.id] == null && (n[r.props.id] = `sb-ui-uniqsvg-${m++}`), e.id = n[r.props.id]), r.props.children && (e.children = i(r.props.children, n)), /* @__PURE__ */ f(r, e);
    }
    return r;
  });
}
function l(p, n) {
  return t.map(p, (r) => {
    if (/* @__PURE__ */ u(r)) {
      const e = {};
      for (const o in r.props)
        typeof r.props[o] == "string" && r.props[o].includes("url") && (e[o] = r.props[o].replace(/url\(#([^()]+)\)/g, (a, s) => `url(#${n[s] || s})`));
      return r.props.children && (e.children = l(r.props.children, n)), /* @__PURE__ */ f(r, e);
    }
    return r;
  });
}
export {
  w
};
//# sourceMappingURL=uniqueSvgIds-KQABKtm8.js.map
